export default "__VITE_ASSET__34e33159__"